/* eslint-disable import/prefer-default-export */
export const CHANGE_CUSTOMER = 'CHANGE_CUSTOMER'
export const CHANGE_CUSTOMER_CONTACT = 'CHANGE_CUSTOMER_CONTACT'
export const CLICK_PHONE_NUMBER = 'CLICK_PHONE_NUMBER'
export const CONVERSATION_SUMMARY_FEEDBACK = 'CONVERSATION_SUMMARY_FEEDBACK'
export const CHANGE_CUSTOMER_RENGA_ID = 'CHANGE_CUSTOMER_RENGA_ID'
